export default "__VITE_ASSET__BrjeZGeC__"